import { BRIEFS } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function BriefBar() {
  return (
    <section id="brief" className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="圈内速递 · 滚不停"
          title="短讯快报，先到先吃"
          desc="一句话一条瓜，节奏快不掺水，标注时间与来源类型。"
          extra={
            <span className="flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-[13px] font-semibold text-secondary-900">
              <span className="relative flex h-2 w-2">
                <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-secondary-600" />
              </span>
              今日已更新 86 条
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {BRIEFS.map((b) => (
            <a
              href="#feed"
              key={b.time}
              className="group flex items-start gap-3.5 rounded-lg bg-background-100 px-4 py-3.5 ring-1 ring-background-200/60 transition-colors hover:bg-background-200/60"
            >
              <span className="mt-0.5 whitespace-nowrap rounded-md bg-accent-100 px-1.5 py-0.5 font-mono text-[12px] font-bold text-accent-900">
                {b.time}
              </span>
              <span className="mt-0.5 shrink-0 whitespace-nowrap rounded bg-primary-100 px-1.5 py-0.5 text-[12px] font-semibold text-primary-800">
                {b.tag}
              </span>
              <p className="min-w-0 flex-1 text-[14px] leading-6 text-foreground-800 transition-colors group-hover:text-primary-700">
                {b.text}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}